import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  ProfileTemplatesListComponent,
  ProfileTemplateFormComponent
} from '../upgrade/profile-templates.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard } from '@fry-it/risr-core';
import { forceOnlineGuard } from '@fry-it/risr-core';

export const profileTemplatesRoutes: Routes = [
  {
    path: 'profile-templates',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'profileTemplates.view'
    },
    children: [
      {
        path: '',
        component: ProfileTemplatesListComponent,
        data: {
          state: 'epf.profile-templates.index'
        }
      },
      {
        path: 'new',
        component: ProfileTemplateFormComponent,
        canActivate: [authGuard],
        data: {
          permission: 'profileTemplates.edit',
          state: 'epf.profile-templates.new'
        }
      },
      {
        path: 'edit/:id',
        component: ProfileTemplateFormComponent,
        canActivate: [authGuard],
        data: {
          permission: 'profileTemplates.edit',
          state: 'epf.profile-templates.edit'
        }
      }
    ]
  }
];
